import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "grid-layout-container mt-0 pa-0" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Users = _resolveComponent("Users")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_GridDrepturiAgenti = _resolveComponent("GridDrepturiAgenti")!
  const _component_v_row = _resolveComponent("v-row")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_v_row, {
      align: "start",
      class: "mt-0"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_col, {
          cols: "4",
          class: "py-0"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_Users, { onSelectionChanged: $options.handleSelectionChanged }, null, 8, ["onSelectionChanged"])
          ]),
          _: 1
        }),
        _createVNode(_component_v_col, {
          cols: "8",
          class: "py-0"
        }, {
          default: _withCtx(() => [
            ($data.selectedRow !== null && $data.selectedRow !== undefined)
              ? (_openBlock(), _createBlock(_component_GridDrepturiAgenti, {
                  key: $data.selectedRow,
                  "user-id": $data.selectedRow
                }, null, 8, ["user-id"]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}